@use '../../global/_mixins.scss' as *;

revogr-focus.focused-cell {
  @include selection(1px);

  position: absolute;
  pointer-events: none;
  z-index: 9;
  display: block !important;
}
